module.exports = __webpack_public_path__ + "img/61.66417ac8.svg";